import React from "react";
import contactImg from "../assets/contact.jpg";
import Navbar from "./Navbar";
import FAQSection from "./FAQSection";
import Footer from "./Footer";

const ContactPage = () => {
  return (
    <>
      <style>{`
        /* ================= HERO ================= */

        .hero {
          position: relative;
          height: 100vh;
          display: flex;
          align-items: center;
          color: white;
          overflow: hidden;
        }

        .hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background: url(${contactImg}) center/cover no-repeat;
          z-index: 1;
        }

        .hero::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(15, 61, 46, 0.9) 0%,
            rgba(15, 61, 46, 0.7) 40%,
            rgba(15, 61, 46, 0.3) 70%,
            rgba(15, 61, 46, 0.1) 100%
          );
          z-index: 2;
        }

        .hero-content {
          position: relative;
          z-index: 3;
          max-width: 600px;
          margin-left: 80px;
        }

        .hero h1 {
          font-size: 48px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 20px;
        }

        .hero p {
          font-size: 16px;
          color: #dcdcdc;
          margin-bottom: 25px;
        }

        .hero-btn {
          background: #7ED957;
          color: black;
          padding: 12px 22px;
          border-radius: 999px;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
        }

        .hero-btn:hover {
          background: #D4AF37;
        }

        /* ================= CONTACT ================= */

        .contact-section {
          background: #DCF6C6;
          padding: 80px 20px;
        }

        .contact-container {
          max-width: 1100px;
          margin: auto;
        }

        .contact-title {
          font-size: 38px;
          font-weight: 700;
          color: #0F3D2E;
          margin-bottom: 40px;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
        }

        .left small {
          color: #555;
          font-size: 13px;
          display: block;
          margin-bottom: 10px;
        }

        .left p {
          font-size: 13px;
          color: #777;
          margin-bottom: 25px;
        }

        .row {
          display: flex;
          gap: 20px;
          margin-bottom: 25px;
        }

        input, textarea {
          width: 100%;
          border: none;
          border-bottom: 1px solid #333;
          background: transparent;
          padding: 8px 0;
          font-size: 14px;
        }

        textarea {
          height: 80px;
        }

        input:focus,
        textarea:focus {
          outline: none;
          border-bottom: 1px solid #0F3D2E;
        }

        .submit-wrap {
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
        }

        .submit-btn {
          background: #7ED957;
          color: black;
          padding: 12px 22px;
          border: none;
          border-radius: 999px;
          cursor: pointer;
        }

        /* RIGHT */

        .right {
          border-left: 1px solid #ccc;
          padding-left: 40px;
        }

        .info-box {
          margin-bottom: 30px;
        }

        .info-box h4 {
          font-size: 14px;
          color: #0F3D2E;
          margin-bottom: 5px;
        }

        .info-box p {
          font-size: 13px;
          color: #777;
          margin-bottom: 5px;
        }

        .info-box span a {
          font-size: 13px;
          color: #27AE60;
          text-decoration: none;
        }

        /* MOBILE */

        @media (max-width: 768px) {
          .hero-content {
            margin: 20px;
          }

          .hero h1 {
            font-size: 32px;
          }

          .contact-grid {
            grid-template-columns: 1fr;
          }

          .right {
            border-left: none;
            padding-left: 0;
          }

          .row {
            flex-direction: column;
          }
        }
      `}</style>

      <Navbar />

      {/* HERO */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            Get in Touch With Our <br />
            Tax & Finance Experts
          </h1>

          <p>
            Have questions or need expert guidance? Reach out to our team
            and get personalized support.
          </p>

          <a href="tel:+919151622122" className="hero-btn">
            Contact Us ↗
          </a>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact-section">
        <div className="contact-container">

          <h2 className="contact-title">Get in touch</h2>

          <div className="contact-grid">

            {/* LEFT */}
            <div className="left">
              <small>Send a Message</small>
              <p>
                Pellentesque in ipsum id orci porta dapibus. Quisque velit nisi,
                pretium ut lacinia in.
              </p>

              <div className="row">
                <input placeholder="Name" />
                <input placeholder="Email Address" />
              </div>

              <div className="row">
                <input placeholder="Interested In" />
                <input placeholder="Phone number" />
              </div>

              <textarea placeholder="Message"></textarea>

              <div className="submit-wrap">
                <button className="submit-btn">+ Submit</button>
              </div>
            </div>

            {/* RIGHT */}
            <div className="right">

              <div className="info-box">
                <h4>Call Us</h4>
                <p>We are available for calls</p>
                <span>
                  <a href="tel:+919151622122">+91 9151622122</a>
                </span>
                <br />
                <span>
                  <a href="tel:+919454332268">+91 9454332268</a>
                </span>
              </div>

              <div className="info-box">
                <h4>Email Us</h4>
                <p>Send us your queries</p>
                <span>
                  <a href="mailto:welthanfinance@gmail.com">
                    welthanfinance@gmail.com
                  </a>
                </span>
              </div>

              <div className="info-box">
                <h4>Visit Us</h4>
                <p>Our Office Address</p>
                <span>A/251 Barra - 6, Kanpur</span>
              </div>

            </div>

          </div>

        </div>
      </section>

      <FAQSection />
      <Footer />
    </>
  );
};

export default ContactPage;